import { apiSlice, fetchAllPaginated } from "./api";
import { resetLoadingProgress, setLoadingProgress } from "./loadingProgressSlice";

const fields = [
  'id', 'slug', 'title.rendered', 'content.rendered', 'excerpt.rendered', 'link',
  'atf_category', 'atf_featured_image', 'tailwater_live',
  'meta.atf_latitude', 'meta.atf_longitude', 'meta.atf_parent_region',
  'meta.atf_address', 'meta.atf_email', 'meta.atf_phone', 'meta.atf_website',
  'meta.atf_hours', 'meta.tailwater_sync_key',
].join(',');

export const atfPOIApiSlice = apiSlice.injectEndpoints({
    endpoints: build => ({
      getPOIs: build.query({
        queryFn: async (_arg, {dispatch}, _extraOptions, baseQuery) => {
            dispatch(resetLoadingProgress());
            return await fetchAllPaginated(
              baseQuery,
              'atf_poi',
              {_fields: fields},
              100,
              2,
              progress => dispatch(setLoadingProgress(progress)),
            );
        },
        providesTags: (result) =>
          result
            ? [
                ...result.map(({ id }) => ({ type: 'atf_poi', id })),
                { type: 'atf_poi', id: 'LIST' },
              ]
            : [{ type: 'atf_poi', id: 'LIST' }],
      }),
    }),
    overrideExisting: true,
});

export const { 
    useGetPOIsQuery
} = atfPOIApiSlice;
